import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/core/material.module';

@Component({

  selector: 'user-management-dialog',
  templateUrl: 'annotations-dialog.component.html',
  styleUrls: ['./annotations-dialog.component.scss'],
  imports: [MaterialModule,CommonModule]
})
export class AnnotationsDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AnnotationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
  }

}
